import Utils from '../../utils/utils.js'
import LogHelper from '../../utils/logHelper.js'
const utilsHelper = new Utils()
import PagePlugin from '../../page_plugin/index.js'

export default class CyberbizTraceService {

    constructor(container_id, config, is_debug, storage_key) {
        this.container_id = container_id
        this.config = config
        this.is_debug = is_debug
        this.storage_key = storage_key
        this.prevent_duplicated = 0
        this.currency_iso = 'TWD'

        // 一天
        this.expired_min = 300
        this.logHelper = new LogHelper(config.LOG_LEVEL, config.LOG_ENDPOINT, is_debug, container_id)
    }

    run() {
        try {

            // 一頁式和一般商品的結帳頁都適用
            if ((window.location.pathname.includes('/events/') || window.location.pathname.includes('/carts/')) && window.location.pathname.includes('conflict') === false) {
                if (window.clarity) {
                    window.clarity("upgrade", "checkout_page")
                }
                this.prePlaceOrderBtnListener()
            }

            // 購買事件，cyberbiz會先到訂單頁，
            if (window.location.pathname.includes('/orders/') && window.location.pathname.includes('account') === false) {
                console.log('optimize99_confirm_order')
                let clid = ''
                try {
                    let s_clid = utilsHelper.getClidByContainerId(this.storage_key)
                    if (s_clid) {
                        clid = s_clid
                    }
                } catch (error) {
                    clid = ''
                }
                if (window.clarity) {
                    window.clarity("upgrade", "purchase_page")
                }
                this.confirmOrder(clid)
            }
            
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_cyberbiz_run',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                }
            })
        }
    }

    // 
    abTestCallBack(views){
        try {
            console.log('optimize99_callback_cyberbiz:', views)

            // if (views.length === 0 ){
            //     return
            // }

            this.addToCart(views)
            
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_cyberbiz_abTestCallBack',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                }
            })
        }
    }

    addToCart(views){

        console.log('optimize99_add2cart', views)
        let that = this
        const cart_btn_ids = [
            // 'btn-add-to-cart', 'btn-main-checkout'
        ]
        const cart_btn_classnames = [
            'add-button', 'addToCart_mobile', 'addToCart',
            'btn_to_cart_mobile', 'btn_quick_buy_mobile',
            'cart-button', 'product-btn'
        ]

        document.addEventListener('click', function(event){
            // console.log('click', event)

            let target_ele = event.target
            if (target_ele instanceof HTMLElement === false) {
                if (target_ele.parentElement instanceof HTMLElement === false) {
                    return
                }
                else {
                    target_ele = target_ele.parentElement 
                }
            }

            let add_cart_btn = null
            let is_match = false

            for(let idx = 0; idx < cart_btn_classnames.length; idx++){
                if (target_ele.closest(`.${cart_btn_classnames[idx]}`)){
                    is_match = true
                    add_cart_btn = target_ele.closest(`.${cart_btn_classnames[idx]}`)
                    break
                } 
            }

            if (is_match === false) {
                for (let idx = 0; idx < cart_btn_ids.length; idx++) {
                    if (target_ele.closest(`#${cart_btn_ids[idx]}`)){
                        add_cart_btn = target_ele.closest(`#${cart_btn_ids[idx]}`)
                        is_match = true
                        break
                    } 
                }
            }

            if (is_match === false) {
                return
            }

            if (that.prevent_duplicated === 1 && window.location.pathname.includes('/events/') === false) {
                that.prevent_duplicated = 0
                return
            }
            that.prevent_duplicated = 1
            that.sendCartEvent(add_cart_btn, views)

        })

    }

    sendCartEvent(add_cart_btn, views){

        try {

            let that = this
            console.log('add_cart_btn', add_cart_btn)
            console.log('views',views)
    
            let product = {
                value: 1,
            }
            // 分是一頁式還是一般商品頁
            if (window.location.href.includes('/events/')) {
    
                product = {
                    content_id: add_cart_btn.getAttribute('data-id'),
                    content_name: add_cart_btn.getAttribute('data-name'),
                    value: 1,
                }
    
            }
            else if(window.location.href.includes('/products/')) {
                product = {
                    content_id: window.c12t.product.id,
                    content_name: window.c12t.product.name,
                    value: window.c12t.product.price
                }
            }
    
            let events = []
            events = views.map(function(view){
                view = view.view
                let event = {
                    "container_id": that.container_id,
                    "event": "AddToCart",
                    "event_id": new Date().getTime(),
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                    "vid": view.vid,
                    "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                    "value": product.value,
                    "content": {
                        contents: [product],
                        currency: that.currency_iso
                    }
    
                }
                return event
            })
    
        
            console.log('optimize99_add_cart_events', events)
            if (events.length === 0) {
                let force_event = {
                    "container_id": that.container_id,
                    "event": "AddToCart",
                    "event_id": new Date().getTime(),
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                    "vid": "",
                    "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                    "value": product.value,
                    "content": {
                        contents: [product],
                        currency: that.currency_iso
                    }
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_cyberbiz_add_cart_force',
                    "request_payload": JSON.stringify(force_event),
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                })
    
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                )
            }

            // 送事件
            events.forEach(function(event){
    
                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_cyberbiz_add_cart',
                    "request_payload": JSON.stringify(event),
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                })
    
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
            })
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_cyberbiz_add_to_cart',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                }
            })
        }

    }

    prePlaceOrderBtnListener(){
        let that = this
        try {
            const cart_btn_ids = [
                'checkout-button', 'checkout-button-block'
            ]

            const cart_btn_classnames = [
                'checkout-btn',
            ]

            document.addEventListener('click', function(event){
                console.log('click', event)
    
                let target_ele = event.target
                if (target_ele instanceof HTMLElement === false) {
                    if (target_ele.parentElement instanceof HTMLElement === false) {
                        return
                    }
                    else {
                        target_ele = target_ele.parentElement 
                    }
                }
    
                let is_match = false
    
                for(let idx = 0; idx < cart_btn_classnames.length; idx++){
                    if (target_ele.closest(`.${cart_btn_classnames[idx]}`)){
                        is_match = true
                        break
                    } 
                }
    
                if (is_match === false) {
                    for (let idx = 0; idx < cart_btn_ids.length; idx++) {
                        if (target_ele.closest(`#${cart_btn_ids[idx]}`)){
                            is_match = true
                            break
                        } 
                    }
                }

                console.log('is_match', is_match)
    
                if (is_match === false) {
                    return
                }

                that.prePlaceOrder()
    
            })

    
        } catch (error) {
            console.log('trace_cyberbiz_perPlaceOrder_btn', error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_cyberbiz_perPlaceOrder_btn',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                }
            })
        }
    }

    prePlaceOrder(){
        console.log('optimize99_checkout_preorder')
        let container_storage = JSON.parse(localStorage.getItem(this.storage_key))
        try {
            let that = this
            let tmp_order_id = application.cart.state.cart.token
            let clid = ''
            try {
                let s_clid = utilsHelper.getClidByContainerId(this.storage_key)
                if (s_clid){
                    clid  = s_clid
                }
            } catch (error) {
                clid = ''
            }
            
            let value = application.cart.state.priceValidations.totalPrice
            let products = []
            application.cart.state.lineItems.forEach(function(item){
                if (item.quantity > 0) {
                    let product = {
                        content_id: item.productId,
                        content_name: item.name,
                        content_sku: item.sku,
                        price: item.price,
                        quantity: item.quantity
                    }
                    products.push(product)
                }
                
            })

            console.log('products', products)
            let recent_seen_views = []
            
            products.forEach(function(product){
                if (container_storage['view_product'][product.content_id]) {
                    let product_views = Object.keys(container_storage['view_product'][product.content_id])
                    for (let idx = 0 ; idx < product_views.length; idx++) {
                        let view = container_storage['view_product'][product.content_id][product_views[idx]]
                        let last_view_at = view.last_view_at
                        let now = new Date().getTime()
                        let duration = now - parseInt(last_view_at)
                        let expired_time = 1000 * 60 * that.expired_min
                        if (duration < expired_time) {
                            if (recent_seen_views.includes(product_views[idx]) === false) {
                                recent_seen_views.push(product_views[idx])
                            }
                        }
                        else {
                            delete container_storage['view_product'][product.content_id][product_views[idx]]
                        }

                    }
                }
            })

            console.log('optimize99_checkout_recent_seen_views ', recent_seen_views)
            let events = []
            events = recent_seen_views.map(function(view_id){
                let event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": `tmp-${tmp_order_id}`,
                    "clid": clid,
                    "vid": view_id,
                    "domain": window.location.hostname,
                    "email": tmp_order_id,
                    "url": window.location.href,
                    "value": value,
                    "content": {
                        contents: products,
                        currency: that.currency_iso
                    }
                }
                return event
            })
            that.logHelper.send({
                "level": 'info',
                "stage": 'trace_cyberbiz_prePlaceOrder_before',
                "request_payload": events,
                "api_url": that.config.API_ENDPOINT + '/view/report',
                "clid": clid,
            })
            console.log('optimize99_checkout_events ', events)
            let plugin_event = {}
            try {
                let pagePlugin = new PagePlugin(
                    this.container_id, this.config
                )
                plugin_event = pagePlugin.purchaseEvent(products)
            } catch (error) {
                console.log('purchase_plugin_error:', error)
            }
            console.log('purchase_plugin_event:', plugin_event)

            if (events.length === 0){
                let force_event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": `tmp-${tmp_order_id}`,
                    "clid": clid,
                    "vid": "",
                    "domain": window.location.hostname,
                    "email": tmp_order_id,
                    "url": window.location.href,
                    "value": value,
                    "content": {
                        contents: products,
                        currency: that.currency_iso
                    }
                }
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0) {
                    force_event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_cyberbiz_prePlaceOrder_force',
                    "request_payload": force_event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": clid,
                })

                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                )

            }

            events.forEach(function(event, event_idx){

                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0 && event_idx === 0) {
                    event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_cyberbiz_prePlaceOrder',
                    "request_payload": event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": clid,
                })

                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
            })

            localStorage.setItem(this.storage_key, JSON.stringify(container_storage))

        } catch (error) {
            console.log('trace_cyberbiz_perPlaceOrder', error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_cyberbiz_perPlaceOrder',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                    container_storage: container_storage 
                }
            })
        }

    }

    async confirmOrder(clid){
        let that = this
        console.log('optimize99_confirmOrder')
        try {

            if (typeof(order_token) !== 'undefined' || typeof(token) !== 'undefined') {
                console.log('optimize99_confirmOrder', 'not_success')
                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_cyberbiz_confirmOrder_payfail',
                    "request_payload": order_token,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                })
                return
            }

            console.log('optimize99_confirmOrder', 'success')

            // 沒clid的狀況
            if (!clid) {
                console.log('optimize99_confirm_order_no_clid')
                let order_id = window.location.pathname.split('/orders/')[1].split('/')[0]
                let event = {
                    "container_id": that.container_id,
                    "domain": window.location.hostname,
                    // 用prePlaceOrder的tmp_order_id來給後端mapping
                    "email": order_id,
                    "value": window.c12t.order.total_price,
                    // 給人看的id
                    "order_id": window.c12t.order.name
                }
                that.logHelper.send({
                    "level": 'info',
                    "stage": 'trace_cyberbiz_confirmOrder_no_clid',
                    "request_payload": event,
                    "api_url": that.config.API_ENDPOINT + '/view/complete',
                })
    
                await utilsHelper.callAPI(
                    '', 
                    'POST', 
                    this.config.API_ENDPOINT + '/view/complete', 
                    event
                )
                return 
            }

            // 有clid的狀況
            // 取訂單資料
            let products = window.c12t.order.line_items.map(function(item){
                let tmp = {
                    platform_product_id: item.product_id,
                    content_id: item.product_id,
                    content_sku: item.sku,
                    content_name: item.title,
                    currency: that.currency_iso,
                    quantity: item.quantity,
                    price: item.price
                }
                return tmp
            })

            let recent_seen_views = []
            let container_storage = JSON.parse(localStorage.getItem(this.storage_key))
            products.forEach(function(product) {
                if (container_storage['view_product'][product.content_id]) {
                    let product_views = Object.keys(container_storage['view_product'][product.content_id])
                    for (let idx = 0 ; idx < product_views.length; idx++) {
                        let view = container_storage['view_product'][product.content_id][product_views[idx]]
                        let last_view_at = view.last_view_at
                        let now = new Date().getTime()
                        let duration = now - parseInt(last_view_at)
                        let expired_time = 1000 * 60 * that.expired_min
                        if (duration < expired_time) {
                            if (recent_seen_views.includes(product_views[idx]) === false) {
                                recent_seen_views.push(product_views[idx])
                            }
                        }
                        else {
                            delete container_storage['view_product'][product.content_id][product_views[idx]]
                        }

                    }
                }
            })
            

            console.log('optimize99_confirm_order_recent_seen_views ', recent_seen_views)
            let events = []
            events = recent_seen_views.map(function(recent_seen_view){
                let event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": window.c12t.order.name,
                    "clid": clid,
                    "vid": recent_seen_view,
                    "url": decodeURIComponent(window.location.href),
                    "value": window.c12t.order.total_price,
                    "content": {
                        contents: products,
                        currency: that.currency_iso
                    }
                }
                return event
            })

            console.log('optimize99_confirm_order_events:', events)
            let plugin_event = {}
            try {
                let pagePlugin = new PagePlugin(
                    this.container_id, this.config
                )
                plugin_event = pagePlugin.purchaseEvent(products)
            } catch (error) {
                console.log('purchase_plugin_error:', error)
            }
            console.log('purchase_plugin_event:', plugin_event)
            if (events.length === 0) {
                let force_event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": window.c12t.order.name,
                    "clid": clid,
                    "vid": "",
                    "url": decodeURIComponent(window.location.href),
                    "value": window.c12t.order.total_price,
                    "content": {
                        contents: products,
                        currency: that.currency_iso
                    }
                }
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0) {
                    force_event["content"]['sales_counter'] = plugin_event['sales_counter']
                }
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                )
                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_cyberbiz_confirmOrder_force',
                    "request_payload": force_event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                })
            }
            events.forEach(function(event, event_idx){
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0 && event_idx === 0) {
                    event["content"]['sales_counter'] = plugin_event['sales_counter']
                }
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_cyberbiz_confirmOrder',
                    "request_payload": event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                })
            })

            recent_seen_views.forEach(function(recent_seen_view){
                products.forEach(function(product) {
                    if (container_storage['view_product'][product.content_id] && container_storage['view_product'][product.content_id][recent_seen_view]) {
                        delete container_storage['view_product'][product.content_id][recent_seen_view]
                    }
                })
            })

            localStorage.setItem(this.storage_key, JSON.stringify(container_storage))
            console.log('optimize99_confirm_order_container_storage:', container_storage)
        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_cyberbiz_confirmOrder',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                }
            })
        }
    }
}